import UseSEO from 'hooks/useSEO/UseSEO';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetUserData } from 'redux/slices/userSlice';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';


export default function UseLoginOut() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [generateUrl] = UseSEO();

    const logOut = () => {
        dispatch(resetUserData());
        localStorage.removeItem('userAccountInformation');
        localStorage.removeItem('itemsRecentSearches');
        window.location.reload();
        navigate(generateUrl(RUTAS_GENERALES_MUL2.main));
    };


    return [logOut] as const;
}
